import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { useGameStore } from '@/store/gameStore'
import { daysRemaining, constructionProgress } from '@/config/constructionConfig'
import { HardHat, Clock, ChevronRight } from 'lucide-react'

// Top-bar works ticker: the classic "construction in progress" timer.
// Shows the soonest job to finish with a live progress bar; clicking opens
// a popover listing every job and deep-links to Instalaciones.
export function ConstructionTimer() {
  const queue = useGameStore(s => s.constructionQueue)
  const day = useGameStore(s => s.day)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  if (queue.length === 0) return null

  const sorted = [...queue].sort((a, b) => a.endDay - b.endDay)
  const next = sorted[0]
  const remaining = daysRemaining(next, day)
  const progress = constructionProgress(next, day)

  const goManage = () => {
    setOpen(false)
    navigate('/facilities')
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        className="construction-ticker"
        onClick={() => setOpen(o => !o)}
        title="Obras en curso"
      >
        <span className="construction-ticker-icon">
          <HardHat size={14} />
        </span>
        <span className="construction-ticker-body">
          <span className="construction-ticker-label">{next.label}</span>
          <span className="construction-ticker-bar">
            <span className="construction-ticker-fill" style={{ width: `${progress * 100}%` }} />
          </span>
        </span>
        <span className="construction-ticker-eta">
          <Clock size={11} />
          {remaining === 0 ? 'Hoy' : `${remaining}d`}
        </span>
        {queue.length > 1 && <span className="construction-ticker-count">+{queue.length - 1}</span>}
      </button>

      <AnimatePresence>
        {open && (
          <>
            <div className="construction-pop-backdrop" onClick={() => setOpen(false)} />
            <motion.div
              className="construction-pop"
              initial={{ opacity: 0, y: -6, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -6, scale: 0.98 }}
              transition={{ duration: 0.16 }}
            >
              <div className="construction-pop-title">
                <HardHat size={13} style={{ color: 'var(--gold)' }} /> Obras en curso
              </div>
              {sorted.map(job => {
                const r = daysRemaining(job, day)
                const p = constructionProgress(job, day)
                return (
                  <div key={job.id} className="construction-pop-row">
                    <div className="construction-pop-row-main">
                      <span className="construction-pop-row-label">{job.label}</span>
                      <span className="construction-ticker-bar" style={{ width: '100%' }}>
                        <span className="construction-ticker-fill" style={{ width: `${p * 100}%` }} />
                      </span>
                    </div>
                    <span className="construction-pop-row-eta">{r === 0 ? 'Hoy' : `${r}d`}</span>
                  </div>
                )
              })}
              <button className="construction-pop-cta" onClick={goManage}>
                Ver instalaciones <ChevronRight size={13} />
              </button>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  )
}
